module.exports = __webpack_public_path__ + "img/heurix_cyberduck_logo.60d66d84.png";